module.exports = __webpack_public_path__ + "img/tongguo_active.b4ae2217.png";